import { useEffect, useSyncExternalStore, type ReactNode } from "react"
import { useRouter } from "next/router"

import type { CoviChatItem } from "../model/types"

interface SofiaPanelContent {
  path: string
  title: string
  node: ReactNode
  getTranscript?: () => CoviChatItem[]
}

// Like the thread header action, pages contribute through a render slot;
// Sofia never imports the feature module. Nothing is registered during SSR.
let content: SofiaPanelContent | null = null
const listeners = new Set<() => void>()
const emit = () => listeners.forEach((listener) => listener())
const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
const snapshot = () => content
const serverSnapshot = () => null

export function useSofiaPanelContent() {
  const router = useRouter()
  const current = useSyncExternalStore(subscribe, snapshot, serverSnapshot)
  return current?.path === router.asPath.split(/[?#]/)[0] ? current : null
}

export function useSetSofiaPanelContent(value: SofiaPanelContent) {
  useEffect(() => {
    content = value
    emit()
    return () => {
      if (content === value) {
        content = null
        emit()
      }
    }
  }, [value])
}
